import { ReactNode } from 'react';

import { useFeatureFlagsContext } from '@app/contexts';
import { getMatchedFeatureFlag } from '@app/utils';
import { Feature, FeatureFlagToMatch } from '@app/constants';

type FeatureFlagDisplayProps<T extends Feature = Feature> = {
  flagToMatch?: FeatureFlagToMatch<T>;
  renderOn?: (flag: ReturnType<typeof getMatchedFeatureFlag<T>>) => ReactNode;
  renderOff?: () => ReactNode;
  children?: ReactNode;
};

export const FeatureFlagDisplay = <T extends Feature = Feature>({
  flagToMatch,
  children,
  renderOn,
  renderOff,
}: FeatureFlagDisplayProps<T>) => {
  const featureFlags = useFeatureFlagsContext();

  if (flagToMatch) {
    const matchedFlag = getMatchedFeatureFlag({
      flags: featureFlags,
      flagToMatch,
    });

    const resolveRender = () => children ?? renderOn?.(matchedFlag);

    return (
      // eslint-disable-next-line react/jsx-no-useless-fragment
      <>{matchedFlag.isActive ? resolveRender() : renderOff?.()}</>
    );
  }

  // eslint-disable-next-line react/jsx-no-useless-fragment
  return <>{children}</>;
};
